import { render, staticRenderFns } from "./DashboardTs.vue?vue&type=template&id=16a1c85c&scoped=true&"
import script from "./DashboardTs.vue?vue&type=script&lang=ts&"
export * from "./DashboardTs.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardTs.vue?vue&type=style&index=0&id=16a1c85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1c85c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('16a1c85c', component.options)
    } else {
      api.reload('16a1c85c', component.options)
    }
    module.hot.accept("./DashboardTs.vue?vue&type=template&id=16a1c85c&scoped=true&", function () {
      api.rerender('16a1c85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dashboard/DashboardTs.vue"
export default component.exports